import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import { 
  Character,
  CharacterItem,
  CharacterSheetInterface,
  RolledValue,
} from "@dndModels";

import CommonUtilities from "@utilities/common_utilities";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import DataUtilities from '@dndUtilities/data_utilities';
import { makeStyles } from "@utilities/theme_utilities";

import CharacterResourceBoxes from "@dndComponents/character/misc/CharacterResourceBoxes";
import DandDButtonBox from "@dndComponents/DandDButtonBox";
import Roller from "@dndComponents/other/Roller";
import ToastBox from "@components/display/ToastBox";

interface Props {
  char: Character; 
  // char_interface: CharacterSheetInterface;
  char_item: CharacterItem;
  // onChange: () => void;
}

const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function ChargesRefreshContol({
  char,
  // char_interface,
  char_item,
  // onChange,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [ping, setPing] = useState(false);
  const [popoverTime, setPopoverTime] = useState(0);
  const [roll, setRoll] = useState<RolledValue[]>([]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        // margin: "4px",
        backgroundColor: theme.palette.secondary.main
      },
    });
  });

  const renderExtras = () => {
    return (
      <ToastBox
        openTime={ popoverTime }
      >
        { renderRoll() }
      </ToastBox>
    );
  }

  const renderRoll = () => {
    return (
      <Roller 
        name="Refresh Charges"
        rolled_values={roll}
        type="Refresh Charges"
      />
    );
  }

  const { classes, cx } = useStyles();
  
  const rolls = char_item.charge_refresh_rolls;
  // console.log(rolls);
  return (
    <div className="padded">
      <Grid container spacing={0} direction="row"
        className={cx(classes.root, "small_label")}>
        <Grid
          size={{
            xs: 5
          }}>
          <div className="centered clickable"
            onClick={() => {

            }}>
            { char_item.name }
          </div>
        </Grid>
        <Grid
          size={{
            xs: 4
          }}>
          <CharacterResourceBoxes 
            used={char_item.charges_used}
            total={char_item.max_charges}
            true_total={char_item.max_charges}
            created={0}
            type={"Charge"}
            show_type={false}
            char={char}
            shared={true}
            onChange={(used: number) => {
              char_item.charges_used = used;
              // onChange();
              char.changed();
              char.subscription_holder.itemsChanged();
              setPing(!ping);
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 3
          }}>
          <DandDButtonBox
            name={ rolls.as_string }
            style={{ fontSize: "9" }}
            disabled={char_item.charges_used === 0}
            onClick={(event: React.MouseEvent<HTMLDivElement>) => {
              if (rolls.size > 1 && rolls.count > 0) {
                const new_roll = char_util.rollOther({ char: char, rolls: [rolls], type: "Charges" });
                char_item.charges_used -= data_util.totalRolledValue(new_roll);
                setRoll(new_roll);
                setPopoverTime(common_util.get_time_number());
              } else {
                char_item.charges_used -= rolls.count + rolls.flat;
              }
              if (char_item.charges_used < 0) {
                char_item.charges_used = 0;
              }
              // onChange();
              char.changed();
              char.subscription_holder.itemsChanged();
              setPing(!ping);
            }} 
          />
        </Grid>
      </Grid>
      { renderExtras() }
    </div>
  );
}
